"use strict";
/**
 * OTP (One-Time Password) related constants
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESEND_COOLDOWN_SECONDS = exports.OTP_VALIDITY_SECONDS = void 0;
/** OTP validity duration in seconds (30 minutes) */
exports.OTP_VALIDITY_SECONDS = 30 * 60;
/** Cooldown duration before allowing resend in seconds (1 minute) */
exports.RESEND_COOLDOWN_SECONDS = 60;
